<template>
    <Carousel
        ref="carousel"
        :analyticsType="analyticsType"
        :name="'catalog-image-viewer'"
        :carouselItems="productImages"
        :desktopSlideSize="CATALOG_IMAGE_VIEWER_DESKTOP_SLIDE_SIZE"
        :mediumSlideSize="CATALOG_IMAGE_VIEWER_MEDIUM_SLIDE_SIZE"
        :mobileSlideSize="CATALOG_IMAGE_VIEWER_MOBILE_SLIDE_SIZE"
        :mobilePeekPercent="CATALOG_IMAGE_VIEWER_MOBILE_PEEK_PERCENT"
        :mobilePeek="mobilePeek"
        :noSlidePadding="true"
        :noContainerMargin="true"
        :translucentButtons="true"
        :onlyShowPaginationOnHover="true"
        :catalogResponseId="catalogResponseId"
        :handleCarouselClick="handleCarouselClick"
    >
        <template
            v-for="(productImage, index) in productImages"
            :key="index"
            #[`carouselItem-${index}`]
        >
            <LazyLoad>
                <template #default="{ hasEnteredViewport }">
                    <BaseLink
                        :to="productLink"
                        class="u-display--block c-catalog-tile__image-container-inner__link"
                        tabindex="-1"
                        @click="handleLinkClick"
                    >
                        <ProductImage
                            :src="productImage"
                            :title="productName"
                            :imagePreset="imagePreset"
                            :isLazyImage="true"
                            :shouldDisplayImage="hasEnteredViewport"
                            :fadeInAfterLoaded="true"
                            :fallbackSrc="fallbackSrc"
                            :allowFocusOutline="true"
                            class="c-catalog-image-viewer__image"
                        />
                    </BaseLink>
                </template>
            </LazyLoad>
        </template>
    </Carousel>
</template>

<script>

import {
    CATALOG_IMAGE_VIEWER_DESKTOP_SLIDE_SIZE,
    CATALOG_IMAGE_VIEWER_MEDIUM_SLIDE_SIZE,
    CATALOG_IMAGE_VIEWER_MOBILE_SLIDE_SIZE,
    CATALOG_IMAGE_VIEWER_MOBILE_PEEK_PERCENT,
} from '~coreModules/catalog/js/catalog-constants';

import Carousel from '~coreModules/core/components/ui/Carousel.vue';
import ProductImage from '~coreModules/core/components/ui/ProductImage.vue';
import LazyLoad from '~coreModules/core/components/ui/LazyLoad.vue';

export default {
    name: 'CatalogImageViewer',
    components: {
        Carousel,
        ProductImage,
        LazyLoad,
    },
    props: {
        analyticsType: {
            type: String,
            default: null,
        },
        productImages: {
            type: Array,
            required: true,
        },
        productLink: {
            type: [Object, String],
            required: true,
        },
        productName: {
            type: String,
            required: true,
        },
        productAnalyticsClick: {
            type: Function,
            default: null,
        },
        // NU_TODO: https://urbnit.atlassian.net/browse/TYP-17531
        // choiceId: {
        //     type: String,
        //     required: true,
        // },
        imagePreset: {
            type: String,
            required: true,
        },
        catalogResponseId: {
            type: String,
            default: null,
        },
        fallbackSrc: {
            type: String,
            default: '',
        },
        mobilePeek: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            CATALOG_IMAGE_VIEWER_DESKTOP_SLIDE_SIZE,
            CATALOG_IMAGE_VIEWER_MEDIUM_SLIDE_SIZE,
            CATALOG_IMAGE_VIEWER_MOBILE_SLIDE_SIZE,
            CATALOG_IMAGE_VIEWER_MOBILE_PEEK_PERCENT,
        };
    },
    computed: {
        pageSize() {
            if (this.$mediaQueries.isSmallish) {
                return this.CATALOG_IMAGE_VIEWER_MOBILE_SLIDE_SIZE;
            }

            if (this.$mediaQueries.isMedium) {
                return this.CATALOG_IMAGE_VIEWER_MEDIUM_SLIDE_SIZE;
            }

            return this.CATALOG_IMAGE_VIEWER_DESKTOP_SLIDE_SIZE;
        },
    },
    methods: {
        handleLinkClick(e) {
            // needs to be called before stop propoagation so select_item fires
            this.productAnalyticsClick();
            // Added to allow users to cmd + click to a new tab and not navigate away
            e.stopPropagation();
        },
        handleCarouselClick() {
            this.productAnalyticsClick();
            this.$router.push(this.productLink);
        },
    },
};
</script>

<style lang="scss">
    .c-catalog-image-viewer {
        &__image {
            width: 100%;
            height: auto;
        }
    }
</style>
